;(function(){
  document.addEventListener('DOMContentLoaded', () => {
    //
    // ───────────────────────────────────────────
    //  0) FORCE default back to subscription on every page load
    // ───────────────────────────────────────────
    sessionStorage.setItem('purchaseOption', 'subscription');

    //
    // ───────────────────────────────────────────
    //  1) Grab & parse your JSON blobs
    // ───────────────────────────────────────────
    const pd = document.querySelector('script[data-product-json]');
    const vs = document.getElementById('VariantSubscriptionData');
    if (!pd || !vs) {
      console.error('custom.js: Missing JSON blobs');
      return;
    }
    let productData, metaData, CURRENCY;
    try {
      productData = JSON.parse(pd.textContent);
      metaData    = JSON.parse(vs.textContent);
      CURRENCY    = metaData.currency || 'USD';
      delete metaData.currency;
    } catch(e) {
      console.error('custom.js: JSON parse error', e);
      return;
    }

    // ───────────────────────────────────────────
    //  Helpers
    // ───────────────────────────────────────────
    function fmt(cents) {
      return new Intl.NumberFormat('es-CR', {
        style: 'currency',
        currency: CURRENCY,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(cents / 10000);
    }

    function getVariantId() {
      const i = document.querySelector('form[action^="/cart/add"] input[name="id"]');
      return i ? Number(i.value) : null;
    }

    // ───────────────────────────────────────────
    //  Rendering functions
    // ───────────────────────────────────────────
    function renderPrices(){
      const vid = getVariantId();
      if (!vid) return;
      const v  = productData.variants.find(x=>x.id===vid);
      const mf = metaData[vid] || {};
      const isOne = sessionStorage.getItem('purchaseOption') === 'one-time';
      const current = isOne
        ? (mf.one_time_price   ?? Math.round(v.price*100))
        : (mf.subscribe_price  ?? Math.round(v.price*100));
      const compare = mf.compare_at_price ?? Math.round((v.compare_at_price||v.price)*100);
      const curEl = document.querySelector('.custom-current-price');
      const cmpEl = document.querySelector('.custom-compare-at');
      if (curEl) curEl.textContent = fmt(current);
      if (cmpEl) {
        if (compare > current) {
          cmpEl.textContent         = fmt(compare);
          cmpEl.style.textDecoration = 'line-through';
          cmpEl.style.opacity        = '.6';
          cmpEl.style.marginRight    = '.5em';
        } else {
          cmpEl.textContent = '';
        }
      }
    }

    function decorateBoxOptions() {
      document.querySelectorAll('.box-save-badge').forEach(el=>el.remove());
      const plan = sessionStorage.getItem('purchaseOption') || 'subscription';
      const key  = plan === 'subscription'
        ? 'subscriptions_saving_amount'
        : 'one_time_saving_amount';
      document.querySelectorAll('.opt-label').forEach(lbl => {
        const txt = lbl.querySelector('.opt-label__text')?.textContent.trim();
        const v   = productData.variants.find(x=>x.options[0]===txt);
        if (!v) return;
        const cents = metaData[v.id]?.[key] || 0;
        if (cents <= 0) return;
        const b = document.createElement('span');
        b.className   = 'box-save-badge';
        b.textContent = `Ahorre ${fmt(cents)}`;
        lbl.appendChild(b);
      });
    }

    function swapSubifyBadge() {
      const vid = getVariantId();
      if (!vid) return;
      const pct  = metaData[vid]?.subscriptions_discount_pct || 0;
      const span = document.querySelector('.subify-max-discount-badge-percentage');
      if (span) span.textContent = `${pct}%`;
    }

    function decorateSubifyCompare() {
      const vid = getVariantId();
      if (!vid) return;
      const mf = metaData[vid] || {};
      const v  = productData.variants.find(x=>x.id===vid);
      const compare = mf.compare_at_price != null
        ? mf.compare_at_price
        : Math.round((v.compare_at_price||v.price)*100);
      document.querySelectorAll('.subify-choice-box-wrapper').forEach(wrapper => {
        const priceSpan = wrapper.querySelector('.subify-choice-price');
        if (!priceSpan) return;
        const disp = Math.round(
          Number(priceSpan.textContent.replace(/[^0-9.]/g,''))*100
        );
        if (compare <= disp) return;
        if (wrapper.querySelector('.subify-choice-compare')) return;
        const cmp = document.createElement('span');
        cmp.className   = 'subify-choice-compare';
        cmp.textContent = fmt(compare);
        priceSpan.parentNode.appendChild(cmp);
      });
    }

    function injectSellingPlan() {
      document
        .querySelectorAll('.subify-selling-plan-whole-wrapper')
        .forEach(wrapper => {
          if (wrapper.querySelector('.custom-selling-plan__list')) return;
          wrapper.innerHTML = `
            <ul class="custom-selling-plan__list">
              <li>✓ Ships Monthly</li>
              <li>✓ Free Shipping</li>
              <li>✓ Cancel or Pause Anytime</li>
            </ul>
          `;
        });
    }

    // ───────────────────────────────────────────
    //  Full paint bundle
    // ───────────────────────────────────────────
    function fullPaint() {
      renderPrices();
      decorateBoxOptions();
      swapSubifyBadge();
      decorateSubifyCompare();
      injectSellingPlan();
    }

    // ───────────────────────────────────────────
    //  2) INITIAL trigger + retry
    // ───────────────────────────────────────────
    fullPaint();
    let tries = 0;
    const handle = setInterval(() => {
      fullPaint();
      if (document.querySelector('.custom-selling-plan__list') || ++tries >= 15) {
        clearInterval(handle);
      }
    }, 100);

    // ───────────────────────────────────────────
    //  3) Repaint on toggles & variant changes
    // ───────────────────────────────────────────
    document.body.addEventListener('click', e => {
      if (!e.target.closest('.subify-choice-box-wrapper div')) return;
      const isOne = !!e.target.closest('.subify-choice-box-wrapper div')
        .querySelector('#subify-widget-one-time-purchase-text');
      sessionStorage.setItem('purchaseOption', isOne ? 'one-time' : 'subscription');
      setTimeout(fullPaint, 50);
    });

    const varInput = document.querySelector('form[action^="/cart/add"] input[name="id"]');
    if (varInput) {
      new MutationObserver(ms => {
        if (ms.some(m=>m.attributeName==='value')) {
          setTimeout(()=>{
            // re-apply last plan
            const plan = sessionStorage.getItem('purchaseOption') || 'subscription';
            const all  = Array.from(document.querySelectorAll('.subify-choice-box-wrapper'));
            const target = plan === 'one-time'
              ? all.find(w=>w.querySelector('#subify-widget-one-time-purchase-text'))
              : all.find(w=>w.querySelector('#subify-widget-subscription-text'));
            target?.querySelector('.checkbox-label')?.click();

            renderPrices();
            decorateBoxOptions();
            swapSubifyBadge();
            decorateSubifyCompare();
          }, 100);
        }
      }).observe(varInput, { attributes: true, attributeFilter: ['value'] });
    }

    // ───────────────────────────────────────────
    //  4) MutationObserver to catch late inserts
    // ───────────────────────────────────────────
    new MutationObserver(muts => {
      muts.forEach(m=>{
        m.addedNodes.forEach(n=>{
          if (n instanceof HTMLElement) {
            if (n.matches('.subify-selling-plan-whole-wrapper') ||
                n.querySelector('.subify-selling-plan-whole-wrapper')) {
              fullPaint();
            }
          }
        });
      });
    }).observe(document.body, {
      childList: true,
      subtree:   true
    });
  });
})();
